import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "./abstract/in-game-ticket-prize-types";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

/**
 * https://evokeplc.atlassian.net/wiki/spaces/CRMSX/pages/542710740/Bonus+Types
 * Pending bonus
 *
 * Is not reflected in player’s BR
 * The player can’t use the money for betting or cash it out
 * This bonus is still waiting for certain user action in order to become ready for use
 * In most cases, once a user fulfills the pending bonus criteria (wagering/deposits?), the bonus will change to 'completed' and user will receive a new Immediate bonus
 * 
 * a.k.a for us "$xx.xx bonus"
 */
export class InGameTicketPendingBonusPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        if (InGameTicketPrizeType.PendingBonus !== _prizeData.prizeType) {
            throw new Error("Pending Bonus cannot be given this prizeType" + _prizeData.prizeType);
        }
        super(_prizeData);
    }
    public prizeString() {
        // return this.services.translation.translate("IGC_IMMEDIATE_BONUS_PRIZE_TEMPLATE", {prizeValue: this.services.currency.formatMoney(this._prizeData.prizeValue)});
        return this.services.currency.formatMoney(this._prizeData.prizeValue) + ' pending bonus';
    }
}
